/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_DescriptionInputs */

const en_sorter_description = /** @type {(inputs: Sorter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort JSON object keys alphabetically. Organize your JSON data for better readability and consistency.`)
};

const ko_sorter_description = /** @type {(inputs: Sorter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 객체 키를 알파벳순으로 정렬하세요. 가독성과 일관성을 위해 JSON 데이터를 정리합니다.`)
};

const ja_sorter_description = /** @type {(inputs: Sorter_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONオブジェクトキーをアルファベット順にソート。可読性と一貫性のためにJSONデータを整理します。`)
};

/**
* | output |
* | --- |
* | "Sort JSON object keys alphabetically. Organize your JSON data for better readability and consistency." |
*
* @param {Sorter_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_description = /** @type {((inputs?: Sorter_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_description(inputs)
	if (locale === "ko") return ko_sorter_description(inputs)
	return ja_sorter_description(inputs)
});